<form [formGroup]="childForm">
  <page-alert message="Endereço Atualizado com sucesso!" *ngIf="showSuccessMessage" alertClass="alert-success"></page-alert>
  <page-alert message="Falha ao atualizar endereço" *ngIf="showErrorMessage" alertClass="alert-danger"></page-alert>
  <div class="row">
    <div class="col-xs-8 col-md-6">
      <mat-form-field class="example-full-width" appearance="outline">
        <mat-label>CEP</mat-label>
        <input type="text" matInput required formControlName="cep" mask="00000-000" placeholder="CEP" />
      </mat-form-field>

      <mat-error *ngIf="childForm.get('cep')?.hasError('required') &&  childForm.get('cep')?.touched"> Campo obrigatório </mat-error>
      <mat-error *ngIf="cepError &&  childForm.get('cep')?.touched"> Nenhum endereço foi encontrado para este CEP. Verifique se está correto ou tente outro.</mat-error>
      <mat-error *ngIf="childForm.get('cep')?.hasError('pattern') && childForm.get('cep')?.touched"> Formato Inválido </mat-error>
    </div>
    <div class="col-xs-2 col-md-2">
      <button mat-flat-button color="primary" (click)="searchAddressByCep()"  [disabled]="submittedCep ||  cepError || childForm.get('cep')?.invalid" class="formBt">Buscar</button>
    </div>
    
  </div>

  <div class="row">
    <div class="col-xs-12 col-sm-6">
      <mat-form-field class="example-full-width" appearance="outline">
        <mat-label>País</mat-label>
        <input
          type="text"
          matInput
          [(ngModel)]="address.country"
          [ngModelOptions]="{ standalone: true }"
          placeholder="País"
          required
          (ngModelChange)="onChangeForm($event)"
          (keypress)="allowOnlyLetters($event)"
        />
      </mat-form-field>
      <mat-error *ngIf="childForm.get('address.country')?.hasError('pattern')"> O nome do país deve conter apenas letras </mat-error>
    </div>
    <div class="col-xs-12 col-sm-6">
      <mat-form-field class="example-full-width" appearance="outline">
        <mat-label>Estado</mat-label>
        <input
          type="text"
          matInput
          [(ngModel)]="address.state"
          [ngModelOptions]="{ standalone: true }"
          placeholder="Estado"
          required
          (ngModelChange)="onChangeForm($event)"
          (keypress)="allowOnlyLetters($event)"
        />
      </mat-form-field>
      <mat-error *ngIf="childForm.get('address.state')?.hasError('pattern')"> O nome do estado deve conter apenas letras </mat-error>
    </div>
    <div class="col-xs-12 col-sm-6">
      <mat-form-field class="example-full-width" appearance="outline">
        <mat-label>Cidade</mat-label>
        <input
          type="text"
          matInput
          [(ngModel)]="address.city"
          [ngModelOptions]="{ standalone: true }"
          placeholder="Cidade"
          required
          (ngModelChange)="onChangeForm($event)"
          (keypress)="allowOnlyLetters($event)"
        />
      </mat-form-field>
      <mat-error *ngIf="childForm.get('address.city')?.hasError('pattern')"> O nome da cidade deve conter apenas letras </mat-error>
    </div>
    <div class="col-xs-12 col-sm-6">
      <mat-form-field class="example-full-width" appearance="outline">
        <mat-label>Logradouro</mat-label>
        <input
          type="text"
          matInput
          [(ngModel)]="address.street"
          [ngModelOptions]="{ standalone: true }"
          placeholder="Cidade"
          required
          (ngModelChange)="onChangeForm($event)"
          (keypress)="allowOnlyLetters($event)"
        />
      </mat-form-field>
      <mat-error *ngIf="childForm.get('address.street')?.hasError('pattern')"> O nome do lagradouro deve conter apenas letras </mat-error>
    </div>
    <div class="col-xs-12 col-sm-6">
      <mat-form-field class="example-full-width" appearance="outline">
        <mat-label>Número</mat-label>
        <input
          type="text"
          matInput
          [(ngModel)]="address.number"
          [ngModelOptions]="{ standalone: true }"
          placeholder="Número"
          required
          (ngModelChange)="onChangeForm($event)"
        />
      </mat-form-field>
    </div>
    <div class="col-xs-12 col-sm-6">
      <mat-form-field class="example-full-width" appearance="outline">
        <mat-label>Complemento</mat-label>
        <input
          type="text"
          matInput
          [(ngModel)]="address.complement"
          [ngModelOptions]="{ standalone: true }"
          placeholder="Complemento"
          (ngModelChange)="onChangeForm($event)"
        />
      </mat-form-field>
    </div>
  </div>

  <div class="col-xs-12 actions">
    <button mat-raised-button color="primary"  (click)="save()" type="submit"   [disabled]="childForm.invalid || isSavingSettings">
      <ng-container *ngIf="!isSavingSettings">Salvar endereço</ng-container>
      <ng-container *ngIf="isSavingSettings">
        <mat-progress-spinner mode="indeterminate" diameter="20" strokeWidth="3"></mat-progress-spinner>
      </ng-container>
    </button>
  </div>
</form>
